import type { AxiosInstance } from "axios";

// Dynamic environment getter
const getLogsEnabled = () => import.meta.env.VITE_ENABLE_LOGS === 'true';

export const setupInterceptors = (api: AxiosInstance) => {
  // ----------------------
  // Request interceptor
  // ----------------------
  api.interceptors.request.use(
    (config) => {
      // Check skipAuth from the config (we'll add it through our request function)
      const skipAuth = (config as any).skipAuth;
      
      if (!skipAuth) {
        const token = localStorage.getItem("authToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }

      if (getLogsEnabled()) {
        console.log(`🚀 [API Request] ${config.method?.toUpperCase()} ${config.url}`, {
          data: config.data,
          params: config.params,
          headers: config.headers,
        });
      }
      return config;
    },
    (error) => {
      if (getLogsEnabled()) console.error("❌ [Request Error]", error);
      return Promise.reject(error);
    }
  );

  // ----------------------
  // Response interceptor
  // ----------------------
  api.interceptors.response.use(
    (response) => {
      if (getLogsEnabled()) {
        console.log(`✅ [API Response] ${response.config.method?.toUpperCase()} ${response.config.url}`, {
          status: response.status,
          data: response.data,
        });
      }
      return response;
    },
    (error) => {
      const message = error.response?.data?.message || error.message;

      if (getLogsEnabled()) {
        console.error("❌ [API Error]", {
          method: error.config?.method?.toUpperCase(),
          url: error.config?.url,
          status: error.response?.status,
          message,
          data: error.response?.data,
        });
      }

      // Example: global auth error handling
      if (error.response?.status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("user");
        // You can dispatch a logout action here
      }

      return Promise.reject(error);
    }
  );
};
